import { useState, useEffect } from "react";

export const useIntersection = (element, rootMargin, initialState) => {
  const visibleState = typeof initialState != "undefined" ? initialState : true;
  const [isVisible, setState] = useState(visibleState);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      { rootMargin }
    );

    element.current && observer.observe(element.current);
    const currentElement = element.current; // To avoid unobserve error
      return () => {
        if (element.current) {
          observer.unobserve(element.current);
        }
      };
  }, []);

  return isVisible;
};
